// extracted by mini-css-extract-plugin
export default {"layout":"DashboardNavigator_layout__aibd5","nav":"DashboardNavigator_nav__a5nOK","menu":"DashboardNavigator_menu__uK+I5"};